"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Popover_1 = __importDefault(require("@mui/material/Popover"));
var Sidebar_module_css_1 = __importDefault(require("./Sidebar.module.css"));
var react_i18next_1 = require("react-i18next");
var ProductMenu = function () {
    var _a = (0, react_1.useState)(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }), t = _b.t, i18n = _b.i18n;
    var nordicScreenLink = i18n.language === "da" ? "https://nordicscreen.com/da" : "https://nordicscreen.com";
    var handleOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var isOpen = Boolean(anchorEl);
    return (react_1.default.createElement("div", { className: Sidebar_module_css_1.default["product-menu"] },
        react_1.default.createElement("button", { className: Sidebar_module_css_1.default["menu-toggle"], onClick: handleOpen },
            react_1.default.createElement("div", null,
                react_1.default.createElement("img", { src: "/images/roundedgrid.svg", alt: "Rounded Grid Icon", className: Sidebar_module_css_1.default["icon-image"] }))),
        react_1.default.createElement(Popover_1.default, { open: isOpen, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: { vertical: "top", horizontal: "right" }, transformOrigin: { vertical: "top", horizontal: "left" }, slotProps: {
                paper: {
                    style: {
                        borderRadius: "5px",
                    },
                },
            }, sx: {
                top: "40px",
                "@media (max-width: 600px)": {
                    "& .MuiPopover-paper": {
                        right: "10px",
                    },
                },
            } },
            react_1.default.createElement("div", { className: Sidebar_module_css_1.default["menu-container"] },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("a", { href: "https://app.q-cal.net", target: "_blank", rel: "noopener noreferrer", className: Sidebar_module_css_1.default.link },
                        react_1.default.createElement("div", { className: Sidebar_module_css_1.default["menu-item"] },
                            react_1.default.createElement("img", { src: "/images/qcal.svg", alt: "Q-Cal", className: Sidebar_module_css_1.default["icon-container"] }),
                            react_1.default.createElement("div", { className: Sidebar_module_css_1.default["text-container"], style: { color: "#222851" } },
                                react_1.default.createElement("h1", { className: "ns-font-family-bold" }, t("Q-Cal - Data Visualization")),
                                react_1.default.createElement("p", null, t("Automate your calendar data and visualize it."))))),
                    react_1.default.createElement("a", { href: "https://app.q-cal.net", target: "_blank", rel: "noopener noreferrer", className: Sidebar_module_css_1.default.link },
                        react_1.default.createElement("div", { className: Sidebar_module_css_1.default["menu-item"] },
                            react_1.default.createElement("img", { src: "/images/qhost.svg", alt: "Q-Host", className: Sidebar_module_css_1.default["icon-container"] }),
                            react_1.default.createElement("div", { className: Sidebar_module_css_1.default["text-container"], style: { color: "#212121" } },
                                react_1.default.createElement("h1", { className: "ns-font-family-bold" }, t("Q-Host - Conference Room Display")),
                                react_1.default.createElement("p", null, t("Ensure efficient use of conference facilities with seamless integrations.")))))),
                react_1.default.createElement("div", { style: { marginBottom: "15px" } },
                    react_1.default.createElement("a", { href: "https://app.q-cal.net", target: "_blank", rel: "noopener noreferrer", className: Sidebar_module_css_1.default.link },
                        react_1.default.createElement("div", { className: Sidebar_module_css_1.default["menu-item"] },
                            react_1.default.createElement("img", { src: "/images/qvisit.svg", alt: "Q-Visit", className: Sidebar_module_css_1.default["icon-container"] }),
                            react_1.default.createElement("div", { className: Sidebar_module_css_1.default["text-container"], style: { color: "#310C6C" } },
                                react_1.default.createElement("h1", { className: "ns-font-family-bold" }, t("Q-Visit - Visitor Management")),
                                react_1.default.createElement("p", null, t("Welcome visitors and create professional digital guest experience."))))),
                    react_1.default.createElement("a", { href: "https://app.q-power.io", target: "_blank", rel: "noopener noreferrer", className: Sidebar_module_css_1.default.link },
                        react_1.default.createElement("div", { className: Sidebar_module_css_1.default["menu-item"] },
                            react_1.default.createElement("img", { src: "/images/qpower.svg", alt: "Q-Power", className: Sidebar_module_css_1.default["icon-container"] }),
                            react_1.default.createElement("div", { className: Sidebar_module_css_1.default["text-container"], style: { color: "#212121" } },
                                react_1.default.createElement("h1", { className: "ns-font-family-bold" }, t("Q-Power - Power Management")),
                                react_1.default.createElement("p", null, t("Automated power control for cost and resource savings.")))))),
                react_1.default.createElement("div", { className: Sidebar_module_css_1.default["menu-footer"] },
                    react_1.default.createElement("a", { href: nordicScreenLink, target: "_blank", rel: "noopener noreferrer", className: Sidebar_module_css_1.default.link },
                        react_1.default.createElement("img", { src: "/images/nslogonotext.png", alt: "NordicScreen Logo", className: Sidebar_module_css_1.default["footer-logo"] }),
                        react_1.default.createElement("span", null, "NordicScreen.com")))))));
};
exports.default = ProductMenu;
